import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { UpdatePaymentScheduleRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { UpdatePaymentScheduleResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const updatePaymentSchedule = (request: UpdatePaymentScheduleRequest, options?: CashRequestOptions) =>
  post<UpdatePaymentScheduleRequest, UpdatePaymentScheduleResponse>('/2.0/cash/update-payment-schedule', request, {
    ...options,
    rejectOnError: true,
  })
